import { Alert, Empty, InputNumber, Table, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, SelectFacturasItem, fmtFechaDia } from "../../../../Components/Items";
import { cantidadTexto, dinero } from "../rmaCompraComun";

// Elige renglones de una factura o remisión del proveedor para agregarlos al RMA. El
// servidor regresa lo que queda por devolver de cada renglón (recibido − devuelto −
// apartado en otros RMAs).
class ElegirRenglonesFacturaRMACompra extends Component {
  state = {
    cargando: false,
    facturaId: undefined,
    factura: null,
    renglones: [],
    seleccion: [],
    cantidades: {},
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ facturaId: undefined, factura: null, renglones: [], seleccion: [], cantidades: {} });
    }
  }

  yaEnRMA(renglon) {
    return (this.props.renglonesActuales || []).some(
      (actual) => actual.facturaRenglonId && String(actual.facturaRenglonId) === String(renglon.facturaRenglonId)
    );
  }

  consultarRenglones(facturaId) {
    this.setState({ facturaId, cargando: true, factura: null, renglones: [], seleccion: [], cantidades: {} });
    if (!facturaId) return this.setState({ cargando: false });
    axios
      .post(
        "rmaCompra/renglonesFacturaRMACompra",
        { empresaId: this.props.empresaId, facturaId, proveedorId: this.props.proveedorId, rmaId: this.props.rmaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error(res.data.message || "No se pudieron leer los renglones de la factura");
          this.setState({ cargando: false });
          return;
        }
        const cantidades = {};
        res.data.renglones.forEach((renglon) => {
          cantidades[renglon.facturaRenglonId] = renglon.pendiente;
        });
        this.setState({ cargando: false, factura: res.data.factura, renglones: res.data.renglones, cantidades });
      })
      .catch(() => {
        message.error("No se pudieron leer los renglones de la factura");
        this.setState({ cargando: false });
      });
  }

  agregar() {
    const elegidos = this.state.renglones
      .filter((renglon) => this.state.seleccion.includes(renglon.facturaRenglonId))
      .map((renglon) => ({
        ...renglon,
        cantidadSolicitada: Number(this.state.cantidades[renglon.facturaRenglonId]) || 0,
      }));
    if (elegidos.length === 0) return message.info("Selecciona al menos un renglón");
    const sinCantidad = elegidos.find((renglon) => renglon.cantidadSolicitada <= 0);
    if (sinCantidad) return message.warning(`Captura la cantidad de "${sinCantidad.descripcion}"`);
    this.props.onAgregar(elegidos);
  }

  render() {
    const { factura } = this.state;
    const moneda = factura?.monedaAbreviacion || "";

    const columnas = [
      { title: "Código", dataIndex: "codigo", key: "codigo", width: 80 },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        render: (value, renglon) => (
          <>
            <div>{value}</div>
            <div style={{ marginTop: 2 }}>
              {this.yaEnRMA(renglon) && <Tag color="blue">Ya está en el RMA</Tag>}
              {renglon.esServicio && <Tag>Servicio</Tag>}
              {renglon.controlaLotes && <Tag>Lotes</Tag>}
              {renglon.controlaMarbetes && <Tag>Marbetes</Tag>}
              {renglon.precioCero && <Tag color="orange">Precio 0</Tag>}
            </div>
          </>
        ),
      },
      { title: "Facturado", dataIndex: "cantidadFacturada", key: "cantidadFacturada", width: 80, align: "center", render: cantidadTexto },
      {
        title: "Recibido",
        dataIndex: "baseDevolvible",
        key: "baseDevolvible",
        width: 75,
        align: "center",
        render: (value, renglon) =>
          factura?.deOrdenDeCompra || renglon.esServicio ? (
            <Tooltip title="Se toma lo facturado: la recepción de esta compra vive en la orden de compra o es un servicio.">
              {cantidadTexto(value)}
            </Tooltip>
          ) : (
            cantidadTexto(value)
          ),
      },
      {
        title: "Devuelto",
        dataIndex: "devuelto",
        key: "devuelto",
        width: 80,
        align: "center",
        render: (value, renglon) =>
          renglon.apartada > 0 ? (
            <Tooltip title={`Además hay ${cantidadTexto(renglon.apartada)} apartados en ${renglon.apartadoEn.join(", ")}`}>
              {cantidadTexto(value)} <Tag color="gold">+{cantidadTexto(renglon.apartada)}</Tag>
            </Tooltip>
          ) : (
            cantidadTexto(value)
          ),
      },
      { title: "Pendiente", dataIndex: "pendiente", key: "pendiente", width: 80, align: "center", render: cantidadTexto },
      {
        title: "A devolver",
        key: "cantidad",
        width: 110,
        render: (value, renglon) => (
          <InputNumber
            size="small"
            min={0}
            max={renglon.pendiente}
            value={this.state.cantidades[renglon.facturaRenglonId]}
            disabled={renglon.pendiente <= 0 || this.yaEnRMA(renglon)}
            onChange={(cantidad) =>
              this.setState((anterior) => ({
                cantidades: { ...anterior.cantidades, [renglon.facturaRenglonId]: cantidad },
              }))
            }
            style={{ width: "100%" }}
          />
        ),
      },
      {
        title: "Precio neto",
        dataIndex: "precioUnitarioNeto",
        key: "precioUnitarioNeto",
        width: 110,
        align: "right",
        render: (value) => `${dinero(value)} ${moneda}`.trim(),
      },
    ];

    return (
      <ModalItem
        title="Agregar renglones desde una factura o remisión"
        visible={this.props.visible}
        spinning={this.state.cargando}
        onCancel={this.props.onCerrar}
        onOk={this.agregar.bind(this)}
        okText="Agregar al RMA"
        footer
        width={window.innerWidth > 1000 ? "75%" : "95%"}
        paddingTop
      >
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>Factura o remisión del proveedor</div>
          {/* key por proveedor: el select solo carga sus primeras facturas al montarse */}
          <SelectFacturasItem
            key={this.props.proveedorId || "sinProveedor"}
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            proveedorId={this.props.proveedorId}
            value={this.state.facturaId}
            onChange={(facturaId) => this.consultarRenglones(facturaId)}
            placeholder="Busca por código de factura"
            width="100%"
          />
        </div>

        {factura && (
          <div style={{ marginBottom: 8, fontSize: 12 }}>
            <b>
              {factura.esRemision ? "Remisión" : "Factura"} {factura.codigoFactura}
            </b>{" "}
            · {fmtFechaDia(factura.fechaFactura)}
            {factura.deOrdenDeCompra ? " · Con orden de compra" : ""}
            {moneda ? ` · ${moneda}` : ""}
          </div>
        )}
        {factura && this.state.renglones.some((renglon) => renglon.devuelto > 0) && (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 8 }}
            message="Lo devuelto sale de las Devoluciones Compra de esta factura. Como esas devoluciones no ligan renglones, se reparte por insumo en el orden de la factura."
          />
        )}

        {this.state.renglones.length > 0 ? (
          <Table
            size="small"
            rowKey="facturaRenglonId"
            dataSource={this.state.renglones}
            columns={columnas}
            pagination={false}
            scroll={{ x: 820 }}
            rowSelection={{
              selectedRowKeys: this.state.seleccion,
              onChange: (seleccion) => this.setState({ seleccion }),
              getCheckboxProps: (renglon) => ({ disabled: renglon.pendiente <= 0 || this.yaEnRMA(renglon) }),
            }}
          />
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={this.state.facturaId ? "La factura no tiene renglones" : "Elige una factura o remisión del proveedor"}
          />
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ElegirRenglonesFacturaRMACompra);
